import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import DeductionService from "../../../../../services/HRM/DeductionService";
import { Translate } from "../../../../Enums/Tranlate";
import DeleteModal from "../../../../common/DeleteModal";

const CardItem = ({ item, setItem, index, setAddModal, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const deductionService = new DeductionService();

	return (
		<tr key={index} className="text-center">
			<td>
				<strong>{item?.employee?.id}</strong>
			</td>
			<td>{item?.employee?.name}</td>
			<td>{item?.type}</td>
			<td>{item?.type === "MONEY" ? item?.amount : item?.days}</td>
			<td>
				{/* {(isExist("edit_deduction") || isExist("delete_deduction")) && ( */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_deduction") && ( */}
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}>
							{" "}
							{Translate[lang]?.edit}
						</Dropdown.Item>
						{/* )} */}
						{/* {isExist("delete_deduction") && ( */}
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							{Translate[lang]?.delete}
						</Dropdown.Item>
						{/* )} */}
					</Dropdown.Menu>
				</Dropdown>
				{/* )} */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.employee?.name}
					deletedItem={item}
					modelService={deductionService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
